import { Component, OnInit, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, map, tap, switchMap, startWith } from 'rxjs/operators';
import { EmailAddressSelected } from './email-address-selected.model';
import { BaseInputDirective } from '../base-input.directive';
import { InternalApiUrls } from '../../../utility/apiurls-internal';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-active-directory-typeahead',
  templateUrl: './active-directory-typeahead.component.html',
  styleUrls: ['./active-directory-typeahead.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports :[
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    CommonModule,
  ],
})
export class ActiveDirectoryTypeaheadComponent extends BaseInputDirective implements OnInit {
  private http = inject(HttpClient);
  private apiUrls = inject(InternalApiUrls);

  @Output() emailSelected: EventEmitter<EmailAddressSelected> = new EventEmitter();
  adUsers$: Observable<string[]> = null;
  minCharacters: number = 2;
  isKnownEmailAddress: boolean = true;



  lookup(value: string): Observable<string[]> {
    if (value && value.length > this.minCharacters) {
      this.isKnownEmailAddress = true;
      const url = `${this.apiUrls.directory.search()}/${value}`;
      return this.http.get<string[]>(url).pipe(
        tap(results => {
          if (results && results.length === 0) {
            this.isKnownEmailAddress = false;
          }
        }),
        map(results => results),

        // catch errors
        catchError(() => of(null)),
      );
    } else {
      return of(null);
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.adUsers$ = this.formControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      switchMap(value => {
        if (value !== '') {
          return this.lookup(value);
        } else {
          return of(null);
        }
      }),
    );
  }

  onOptionSelected($event) {
    const item: EmailAddressSelected = {
      emailAddress: $event.option.value,
      isWCBEmail: this.isKnownEmailAddress,
    };

    this.emailSelected.emit(item);
  }

  onTextChanged($event) {
    const item: EmailAddressSelected = {
      emailAddress: $event.currentTarget.value,
      isWCBEmail: this.isKnownEmailAddress,
    };
    this.emailSelected.emit(item);
  }
}
